<div class="p-6">
  <div
    class="relative -ml-6 -mr-6 -mt-6 flex h-14 items-center justify-center gap-2 border-b border-grey-7 border-b-grey-8"
  >
    <div
      class="inline-flex h-6 w-6 items-center justify-center rounded-full bg-apricot-2"
    >
      <app-ui-icon color="var(--white)" name="star_filled" size="sm"></app-ui-icon>
    </div>
    <h2 class="font-bold">Lämna ett omdöme</h2>
    <button
      (click)="closeDialog()"
      class="icon-button absolute top-1 right-1"
      type="button"
    >
      <app-ui-icon
        class="close-icon"
        color="var(--grey-1)"
        name="close"
      ></app-ui-icon>
    </button>
  </div>

  <div>
    <p class="my-4 text-lg font-bold">
      Vad tyckte du om ditt besök på {{ rateComponentData.name }}?
    </p>
    <div
      *ngIf="rateComponentData.reviewSettings !== null"
      class="flex flex-col gap-6"
    >
      <mat-error *ngIf="hasRatingsError">
        Vänligen, betygsätt ditt besök
      </mat-error>
      <div
        *ngFor="
          let question of rateComponentData.reviewSettings.reviewQuestions;
          trackBy: reviewQuestionsTrackBy
        "
        class="flex flex-col gap-2 md:flex-row"
      >
        <div class="md:min-w-[20rem]">
          <b>{{ question.name }}</b>
          <p class="text-sm text-grey-6">{{ question.description }}</p>
        </div>
        <div>
          <app-rate-input
            (rateChanged)="handleRateChanged($event, question.id)"
            [rate]="0"
          ></app-rate-input>
        </div>
      </div>
    </div>

    <form [formGroup]="userDataForm">
      <div class="my-4 flex gap-2">
        <div class="flex h-6 w-6 items-center justify-center">
          <app-ui-icon color="var(--grey-2)" name="info" size="sm"></app-ui-icon>
        </div>
        <p class="text-grey-2">
          Vården.se granskar alla omdömen innan de publiceras. Vi publicerar
          inte omdömen som innehåller personuppgifter, grovt språk,
          personangrepp eller kommentarer gällande diagnoser och medicinering.
        </p>
      </div>
      <div>
        <mat-form-field
          appearance="outline"
          class="full-width"
          hintLabel="Max. {{ maxCommentLength }} tecken"
        >
          <textarea
            #kommentar
            [maxLength]="maxCommentLength"
            formControlName="comment"
            matInput
            placeholder="Kommentar"
          ></textarea>
          <mat-hint align="end"
          >{{ kommentar.value?.length || 0 }}/{{ maxCommentLength }}
          </mat-hint
          >
          <mat-error *ngIf="userDataForm.controls.comment.hasError('required')">
            Kommentar <strong>krävs</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field
          appearance="outline"
          class="full-width"
        >
          <input [maxLength]="maxNameLength" formControlName="firstname" matInput placeholder="Förnamn">
          <mat-error
            *ngIf="userDataForm.controls.firstname.hasError('required')"
          >
            Förnamn <strong>krävs</strong>
          </mat-error>
          <mat-error
            *ngIf="userDataForm.controls.firstname.hasError('maxlength')"
          >
            Förnamn <strong>maximal längd är {{ maxNameLength }}</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field
          appearance="outline"
          class="full-width"
        >
          <input
            [maxLength]="maxNameLength"
            formControlName="lastname"
            matInput
            placeholder="Efternamn (publiceras ej)"
          >
          <mat-error
            *ngIf="userDataForm.controls.lastname.hasError('required')"
          >
            Efternamn <strong>krävs</strong>
          </mat-error>
          <mat-error
            *ngIf="userDataForm.controls.lastname.hasError('maxlength')"
          >
            Efternamn <strong>maximal längd är {{ maxNameLength }}</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field
          appearance="outline"
          class="full-width">
          <input
            [maxLength]="maxEmailLength"
            formControlName="email"
            matInput
            placeholder="E-postadress (publiceras ej)"
          >
          <mat-error
            *ngIf="
              userDataForm.controls.email.hasError('email') &&
              !userDataForm.controls.email.hasError('required')
            "
          >
            Ange en giltig e-postadress
          </mat-error>
          <mat-error *ngIf="userDataForm.controls.email.hasError('required')">
            E-postadress <strong>krävs</strong>
          </mat-error>
          <mat-error
            *ngIf="userDataForm.controls.email.hasError('maxlength')"
          >
            E-postadress <strong>maximal längd är {{ maxEmailLength }}</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="mb-2">
        <mat-checkbox formControlName="policy"
        >Jag har läst och godkänner
          <a [routerLink]="omdomenPolicyUrl" class="underline" target="_blank"
          >Policy för omdömen</a>, <a [routerLink]="vilkorUrl" class="underline" target="_blank">Allmänna villkor</a>
          samt
          <a
            [routerLink]="integritetsPolicyUrl"
            class="underline"
            target="_blank"
          >Integritetspolicy</a>
        </mat-checkbox>
        <mat-error
          *ngIf="
            userDataForm.controls.policy.hasError('pattern') &&
            !userDataForm.controls.policy.untouched
          "
        >För att skicka in ditt omdöme måste du godkänna vår Policy för
          omdömen, Allmänna villkor samt Integritetspolicy.
        </mat-error>
      </div>
      <div class="mb-4">
        <mat-checkbox formControlName="newsletter"
        >Jag samtycker till att få nyhetsbrev och information om erbjudanden från Vården.se
        </mat-checkbox>
      </div>
    </form>

    <div *ngIf="formHasError">
      <mat-error>Fyll i alla obligatoriska fält</mat-error>
    </div>
  </div>
  <div class="modal-actions flex flex-col gap-2 md:flex-row" mat-dialog-actions>
    <app-ui-button (click)="saveRating()" color="green" expanded="block"
    >Skicka
    </app-ui-button
    >
    <app-ui-button (click)="closeDialog()" color="ghost" expanded="block"
    >Stäng
    </app-ui-button
    >
  </div>
</div>
